export default {
  state: {
    other: {
      currentPage: '',
      currentTab: '',
      runsInMap: [],
      sendTimer: {}
    }
  },
  mutations: {
    setOtherData (state, data) {
      for (let field in data) {
        state.other[field] = data[field]
      }
    },
    setRunsInMap (state, id) {
      let i = state.other.runsInMap.indexOf(id)
      if (i > -1) {
        state.other.runsInMap.splice(i, 1)
      } else {
        state.other.runsInMap.push(id)
      }
    },
    removeRunsInMap (state, id) {
      let i = state.other.runsInMap.indexOf(id)
      if (id > -1) {
        state.other.runsInMap.splice(i, 1)
      }
    },
    setSendTimer (state, data) {
      state.other.sendTimer[`a${data.id}`] = data.time
    },
    deleteSendTimer (state, id) {
      delete state.other.sendTimer[`a${id}`]
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/runs/other.js